export default __webpack_public_path__ + "static/media/EngenderTrust.8397f37b.svg";